import React,{createContext,useCallback,useContext,useMemo,useRef,useState} from 'react';

const idle={busy:false,setBusy:()=>{},isBusy:()=>false};
const Context=createContext(idle);
// Scoped to the three scanner holders. Other portal modules keep their current
// navigation. The ref closes the event-to-render gap while a POST starts.
export function TrackingNavigationProvider({children}){
 const ref=useRef(false),[busy,setState]=useState(false);
 const setBusy=useCallback(value=>{ref.current=Boolean(value);setState(ref.current);},[]);
 const isBusy=useCallback(()=>ref.current,[]);
 const value=useMemo(()=>({busy,setBusy,isBusy}),[busy,setBusy,isBusy]);
 return <Context.Provider value={value}>{children}</Context.Provider>;
}
export const useTrackingNavigation=()=>useContext(Context);
